"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketRuleUnknownCondition = void 0;
const market_rule_condition_1 = require("./market-rule-condition");
class MarketRuleUnknownCondition extends market_rule_condition_1.MarketRuleCondition {
    /**
     * Constructor
     * @param obj Source object for fields initialiazation
     */
    constructor(obj) {
        super(obj);
    }
}
exports.MarketRuleUnknownCondition = MarketRuleUnknownCondition;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFya2V0LXJ1bGUtdW5rbm93bi1jb25kaXRpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi8uLi8uLi9zcmMvY29udGVudC9oaXN0b3JpY2FsLXByaWNpbmcvdGltZS1zZXJpZXMvc2VydmljZXMvcnVsZS1lbmdpbmUtc2VydmljZS9jbGFzc2VzL21hcmtldC1ydWxlLXVua25vd24tY29uZGl0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLG1FQUE4RDtBQUU5RCxNQUFhLDBCQUEyQixTQUFRLDJDQUFtQjtJQUMvRDs7O09BR0c7SUFDSCxZQUFtQixHQUF5QztRQUN4RCxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUM7SUFDZixDQUFDO0NBQ0o7QUFSRCxnRUFRQyJ9